/**
 * @created        16/09/2023 - 16:09
 * @author         Nariman Palangi
 * @user           ragnarok
 * @organization
 * @project        boilerplate-vue-3
 * @file name      fa.js
 * @file dir       src/locales
 */

export default {
        validations: {
                alpha: "{property} فقط می تواند از حروف تشکیل شود",
                alpha_num: "{property} فقط میتواند از حروف و اعداد تشکیل شود",
                alpha_dash:
                    "{property} فقط می تواند از حروف، اعداد، خط فاصله و زیرخط تشکیل شود",
                alpha_spaces: "{property} فقط می تواند از حروف و فاصله تشکیل شود",
                between: "{property} باید بین {min} و {max} کارکتر باشد",
                confirmed: "{property} با رمز عبور مطابقت ندارد",
                digits: "{property} باید یک مقدار عددی و دقیقاً {length} رقم باشد",
                dimensions:
                    "{property} باید در اندازه {width} پیکسل عرض و {height} پیکسل ارتفاع باشد",
                email: "{property} باید یک ایمیل(رایانامه) معتبر باشد",
                excluded: "{property}باید یک مقدار معتبر باشد",
                ext: "{property} باید یک فایل معتبر باشد",
                image: "{property} باید یک تصویر باشد",
                max_value: "مقدار {property} باید {max} یا کمتر باشد",
                max: "{property} نباید بیشتر از {length} کارکتر باشد",
                length: "{property} نباید بیشتر از 11 کارکتر باشد",
                mimes: "{property} باید از نوع معتبر باشد",
                min_value: "مقدار {property} باید {min} یا بیشتر باشد",
                doubleMainPositive: "مقدار {property} باید مثبت باشد.",
                min: "{property} باید حداقل {length} کارکتر باشد",
                numeric: "{property} فقط می تواند عددی باشد",
                oneOf: "{property} باید یک مقدار معتبر باشد",
                regex: "قالب {property} قابل قبول نیست",
                required_if: "{property} الزامی است",
                required: "{property} الزامی است",
                averageRequired: "{property} الزامی است",
                size: "حجم {property} کمتر از {size}KB باشد",
                double: "قسمت {property} باید یک اعشار معتبر باشد",
                minLength: "مقدار {property} باید {min} یا بیشتر باشد",
                maxLength: "مقدار {property} باید {max} یا کمتر باشد",
                isEnglish: "لطفا {property} را به انگلیسی وارد کنید.",
                isPersian: "لطفا {property} را به فارسی وارد کنید.",
                mobile: "لطفا {property} را با فرمت صحیح وارد کنید.",
                sameAsMultiple: "مقدار {property} معتبر نمی باشد.",
                colorRequired: "مقدار نام و کد رنگ الزامی می باشد.",
                doubleRequired: "مقدار هر دو فیلد الزامی می باشد.",
                strongPassword:
                    "پسورد باید شامل حروف کوچک و بزرگ و کارکترهای ویژه $#%^&*@ باشد.",
                sameAsPassword: "مقدار {property} با رمز عبور برابر نیست.",
                sameAsTerms: "لطفا {property} را تایید بفرمایید.",
        },
        property: {
                username: "نام کاربری",
                password: "رمز عبور",
                new_password: "رمز عبور",
                confirm: "تکرار رمز عبور",
                new_password_confirmation: "تکرار رمز عبور",
                email: "ایمیل",
                mobile: "شماره تماس",
                name_family: "نام و نام‌خانوادگی",
                name: "نام و نام‌خانوادگی",
                name_english: "نام و نام‌خانوادگی(انگلیسی)",
                grade: "پایه تحصیلی",
                field_of_study: "رشته تحصیلی",
                school_type: "نوع مدرسه",
                code: "کد معرف",
                title: "عنوان مشکل",
                message: "جزییات مشکل",
                avatar: 'عکس پروفایل',
                province: 'استان',
                city: 'شهر',
                gender: 'جنسیت',
                familiarity_way: 'نحوه آشنایی',
                terms: 'شرایط و قوانین',
                question_title: 'عنوان سوال',
                question_text: 'متن سوال',
                teacher_name: 'استادت رو پیدا کن',
                avg_score: 'معدل کل',
                literature_score: 'یش بینی نمره ادبیات',
                math_score: 'پیش بینی نمره ریاضی',
                science_score: 'پیش بینی نمره علوم',
                arabic_score: 'پیش بینی نمره عربی',
                technical_science_score: 'پیش بینی نمره علوم‌و‌فنون',
                biology_score: 'پیش بینی نمره زیست',
                chemistry_score: 'پیش بینی نمره شیمی',
                floating: 'اعشار',
                integer: 'صحیح',
        },
        username: "نام کاربری",
        password: "رمز عبور",
        new_password: "رمز عبور",
        school_type: "نوع مدرسه",
        confirm: "تکرار رمز عبور",
        new_password_confirmation: "تکرار رمز عبور",
        email: "ایمیل",
        mobile: "شماره تماس",
        name_family: "نام و نام‌خانوادگی",
        name: "نام و نام‌خانوادگی",
        name_english: "نام و نام‌خانوادگی(انگلیسی)",
        grade: "پایه تحصیلی",
        field_of_study: "رشته تحصیلی",
        code: "کد معرف",
        title: "عنوان مشکل",
        avatar: 'عکس پروفایل',
        province: 'استان',
        city: 'شهر',
        gender: 'جنسیت',
        familiarity_way: 'نحوه آشنایی',
        terms: 'شرایط و قوانین',
        avg_score: 'معدل کل',
        literature_score: 'یش بینی نمره ادبیات',
        math_score: 'پیش بینی نمره ریاضی',
        science_score: 'پیش بینی نمره علوم',
        arabic_score: 'پیش بینی نمره عربی',
        technical_science_score: 'پیش بینی نمره علوم‌و‌فنون',
        biology_score: 'پیش بینی نمره زیست',
        chemistry_score: 'پیش بینی نمره شیمی',
        floating: 'اعشار',
        integer: 'صحیح',
        message: "جزییات مشکل",
        question_title: 'عنوان سوال',
        question_text: 'متن سوال',
        UPDATED_SUCCESS: "به روز رسانی با موفقیت انجام شد.",
        UPDATED_FAILED: "به روز رسانی انجام نشد.",
        SEND_EMAIL_SUCCESS: "کد یکبار مصرف به ایمیل شما ارسال شد.",
        FAILED_TO_SEND_EMAIL: "کد یک بار مصرف به ایمیل شما ارسال نشد.",
        LOGIN_SUCCESS: "ورود با موفقیت انجام شد.",
        FAILED_LOGIN: "ورود انجام نشد.",
        CREATE_SUCCESS: "با موفقیت ایجاد شد.",
        CREATE_FAILED: "ایجاد نشد.",
        VERIFY_SUCCESS: "با موفقیت تایید شد.",
        VERIFY_FAILED: "تایید نشد.",
        FAILED_FETCH: "دریافت اطلاعات از سرور با خطا مواجه شده است.",
        UNAUTHORIZED: "دسترسی غیر مجاز"

}